module.exports = (theme) => ({
  ".hero-container": {
    position: "relative",
    width: "100%",
  },
  ".hero-content-container": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "310px",
  },
  ".hero-content": {
    position: "relative",
    textAlign: "center",
    paddingTop: theme("spacing.xl"),
    paddingBottom: theme("spacing.xl"),
    paddingLeft: theme("spacing.lg"),
    paddingRight: theme("spacing.lg"),
    maxWidth: theme("screens.lg"),
    margin: "auto",
  },
  ".hero-bg-image": {
    backgroundColor: theme("colors.primary.gray.DEFAULT"),
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50% 50%",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    position: "absolute",
    display: "none",
  },

  ".hero-preamble": {
    maxWidth: theme("screens.lg"),
    textAlign: "center",
  },

  [`@media screen and (max-width: ${theme("screens.sm")})`]: {
    ".hero-bg-image-sm": {
      display: "block",
    },
    ".hero-preamble": {
      marginLeft: theme("spacing.DEFAULT"),
      marginRight: theme("spacing.DEFAULT"),
      fontSize: theme("fontSize.xl"),
      lineHeight: theme("lineHeight.base"),
    },
  },
  [`@media screen and (min-width: ${theme("screens.sm")}) and (max-width: ${theme("screens.lg")})`]: {
    ".hero-bg-image-md": {
      display: "block",
    },
    ".hero-preamble": {
      marginLeft: theme("spacing.xl"),
      marginRight: theme("spacing.xl"),
    },
  },

  [`@media screen and (min-width: ${theme("screens.lg")})`]: {
    ".hero-bg-image-lg": {
      display: "block",
    },
    ".hero-preamble": {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
});
